import * as actions from './actions'

export const getInfo = [
  actions.getInfo,
]
